<template>
	<el-dialog title="将产品授权给学院" :visible.sync="outerVisible" :before-close="beforeClose">
		<el-row>
			<el-col>
				<p>
					<el-input v-model="searchName" prefix-icon="el-icon-search" placeholder="请输入学校关键字进行检索"></el-input>
				</p>
			</el-col>
			<el-col>
				<el-table :data="showData()" style="width: 100%;margin-bottom: 20px;" row-key="id" border
					:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
					<el-table-column prop="name" label="学校/学院" sortable>
					</el-table-column>
					<el-table-column prop="stopTime" label="到期时间" sortable>
						<template slot-scope="scope">
							<el-date-picker v-model="scope.row.stopTime" type="datetime" placeholder="选择日期时间"
								align="right" :picker-options="pickerOptions">
							</el-date-picker>
						</template>
					</el-table-column>
					<el-table-column prop="active" label="操作" width="180" sortable>
						<template slot-scope="scope">
							<el-switch v-model="scope.row.active" @change="setActive(scope.row)" active-color="#13ce66"
								inactive-color="#ff4949">
							</el-switch>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="productCount"
					class="text-align-center m-t-15" @size-change="sizeChange" @current-change="currentChange">
				</el-pagination>
			</el-col>
		</el-row>

		<div slot="footer" class="dialog-footer">
			<!-- <el-button @click="beforeClose">取 消</el-button> -->
			<el-button type="primary" @click="save">关 闭</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				page_size: 10,
				page_current: 1,
				productCount: 0,
				searchName: '',
				tableData: [],
				pickerOptions: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '明天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}, {
						text: '一月',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					}, {
						text: '半年',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 180);
							picker.$emit('pick', date);
						}
					}, {
						text: '一年',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 360);
							picker.$emit('pick', date);
						}
					}, {
						text: '十年',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 3600);
							picker.$emit('pick', date);
						}
					}]
				}
			};
		},
		props: {
			outerVisible: {
				type: Boolean,
				default: false
			},
			objdata: {
				type: Object
			}
		},
		created() {

		},
		watch: {
			outerVisible(val) {
				if (val) {
					this.loadData()
				}
			}
		},
		methods: {
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showData() {
				let _data = this.tableData.filter(item => item.name.search(this.searchName) > -1)
				this.productCount = _data.length
				return _data.slice((this.page_current -
					1) * this.page_size, this.page_current * this.page_size)
			},
			loadData() {
				this.$http.get('api/Product/GetProduct_Org_AuthList/' + this.objdata.id).then(
					res => {
						this.tableData = res.data.data
					})
			},
			setActive(val) {
				if (!val.stopTime) {
					val.active = !val.active
					this.$message({
						message: "请先设置到期时间",
						type: 'info'
					})
					return false
				}

				let product_org = []

				if (val.children) {
					val.children = val.children.map(c => {
						c.active = val.active
						c.stopTime = val.stopTime

						product_org.push({
							productID: this.objdata.id,
							schoolID: c.schoolId,
							deptID: c.id,
							active: c.active,
							stopTime: c.stopTime
						})
						return c
					})
				} else {
					this.tableData.map(item => {
						if (item.children.filter(c => c.active).length > 0) {
							item.active = true
						} else {
							item.active = false
						}
					})

					product_org.push({
						productID: this.objdata.id,
						schoolID: val.schoolId,
						deptID: val.id,
						active: val.active,
						stopTime: val.stopTime
					})
				}


				console.log(product_org)
				//保存
				product_org.map(item => {
					this.$http.post('api/Product/SaveProduct_Orgs', item).then(res => {
						if (res.data.code == "1") {
							this.$message({
								message: "设置成功",
								type: 'success'
							})
						} else {
							this.$message({
								message: "设置失败：" + res.data.message,
								type: 'error'
							})
						}
					})
				})
			},
			save() {
				this.beforeClose(true)
			},
			beforeClose(val) {
				this.$emit('before-Close', val)
			}
		}
	}
</script>
